import {isClient} from "@/shared/utils/runtime";

export function scrollToPromise(
    top: number,
    {
        behavior = "smooth",
        threshold = 2,
        timeout = 2000,
    }: {
        behavior?: ScrollBehavior;
        threshold?: number;
        timeout?: number;
    } = {},
): Promise<void> {
    return new Promise((resolve) => {
        if (!isClient()) {
            resolve();
            return;
        }

        const start = performance.now();

        window.scrollTo({top, behavior});

        function check(): void {
            const current = window.scrollY;

            if (Math.abs(current - top) <= threshold) {
                resolve();
                return;
            }

            if (performance.now() - start > timeout) {
                // fallback to avoid hanging
                resolve();
                return;
            }

            requestAnimationFrame(check);
        }

        requestAnimationFrame(check);
    });
}
